import { Dialog, Button } from '@workspace/design-system/src/components';
const interactiveTechnologies = {
    'InputText' : '텍스트 입력',
    'InputDirection' : '방향 입력',
    'InputPassword' : '4자리 비밀번호 입력',
    'Button' : '버튼 클릭',
    'WebView' : '웹뷰 페이지 활용',
    'Ar' : '[카메라] AR 이미지 인식',
    'Qr' : '[카메라] QR 코드 인식',
    'PhotoFrame' : '[카메라] 프레임 사진 촬영',
    'Nfc' : '[NFC] NFC 태그 인식',
    'Gps' : '[GPS] 특정 장소로 이동',
    'ColorFilter' : '[카메라] 컬러 필터 렌즈',
    'Overlap' : '[카메라] 오버랩',
    'Item' : '아이템',
    'Chatbot' : '챗봇'
}
interface ContentDetailModalProps {
    content: {
        id: string;
        imageUrl: string;
        name: string;
        description: string;
        interactiveTechnologies?: string[];
    };
    onClose: () => void;
}

export default function ContentDetailModal({ content, onClose }: ContentDetailModalProps) {
    return (
        <Dialog>
            <Dialog.Content className="max-w-[1200px] max-h-[840px] flex flex-col">
                <div className="max-h-[648px] min-h-80 p-10 flex flex-col gap-10">
                    <h2 className="text-text-default text-size-3 font-bold leading-font-height-3">
                        콘텐츠 정보
                    </h2>

                    <div className="flex flex-col gap-6">
                        <img
                            className="w-[120px] h-24 rounded-lg object-cover"
                            src={content.imageUrl}
                            alt={content.name}
                        />

                        <table className="w-full border border-border">
                            <tbody>
                                <tr className="h-10 shadow-[0px_-1px_0px_0px_#EDEDED_inset]">
                                    <th className="w-28 px-4 py-2 bg-surface-section text-left text-text-default text-size-6 font-bold leading-font-height-6">
                                        콘텐츠 이름
                                    </th>
                                    <td className="px-4 py-2 text-text-default text-size-6 font-regular leading-font-height-5 tracking-[-0.1px]">
                                        {content.name}
                                    </td>
                                </tr>
                                <tr className="h-10 shadow-[0px_-1px_0px_0px_#EDEDED_inset]">
                                    <th className="w-28 px-4 py-2 bg-surface-section text-left text-text-default text-size-6 font-bold leading-font-height-6">
                                        한 줄 설명
                                    </th>
                                    <td className="px-4 py-2 text-text-default text-size-6 font-regular leading-font-height-5 tracking-[-0.1px]">
                                        {content.description}
                                    </td>
                                </tr>
                                <tr className="h-10 shadow-[0px_-1px_0px_0px_#EDEDED_inset]">
                                    <th className="w-28 px-4 py-2 bg-surface-section text-left text-text-default text-size-6 font-bold leading-font-height-6">
                                        실감 기술
                                    </th>
                                    <td className="px-4 py-2 text-text-default text-size-6 font-regular leading-font-height-5 tracking-[-0.1px]">
                                        {content.interactiveTechnologies && content.interactiveTechnologies.length > 0
                                            ? content.interactiveTechnologies
                                                  .map((tech) => interactiveTechnologies[tech as keyof typeof interactiveTechnologies] || tech)
                                                  .join(', ')
                                            : '-'}
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>

                <Dialog.Footer>
                    <Button styleType="basic" styleSize="M-40" onClick={onClose}>
                        닫기
                    </Button>
                </Dialog.Footer>
            </Dialog.Content>
        </Dialog>
    );
}

